var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticStyle: { width: "100%" }, attrs: { "pa-0": "" } },
    [
      _c("div", { staticClass: "headline pt-4 pb-2" }, [
        _vm._v(" Active Services "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.activeServices, function (service) {
        return _c("ServiceItem", {
          key: service.id,
          attrs: { service: service },
        })
      }),
      _vm._v(" "),
      _vm.activeServices.length == 0
        ? _c("p", [_vm._v("There are no active services.")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "headline pt-4 pb-2" }, [
        _vm._v(" Inactive Services "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.inactiveServices, function (service) {
        return _c("ServiceItem", {
          key: service.id,
          attrs: { service: service },
        })
      }),
      _vm._v(" "),
      _vm.inactiveServices.length == 0
        ? _c("p", [_vm._v("There are no inactive services.")])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }